
import axios from '@/config/http'
import ip from '../config/ip.js'


let base = ip.Ips.ip1
let base2 = ip.Ips.ip2

//订单  查询已派单&待派单列表
export const querySendOrderList = params => {
  return axios.post(`${base}/api/workOrder/order/query_send_order_list`, params);
};

//订单  查询订单修改记录
export const getHistoryList = params => {
  return axios.get(`${base}/api/workOrder/order_change_history/get_history_list`, { params: params });
};

//订单  查询物料
export const getQueryMaterial = params => {
  return axios.get(`${base}/api/inventory/query_lessee_inventory`, { params: params });
};

//筛选工程师
export const queryEngineerKb = params => {
  return axios.post(`${base}/api/EngineerInfo/query_engineer_kb`, params);
};

export const selectWorkOrder = params => {
  return axios.post(`${base}/api/workOrder/order/selectWorkOrder`, params);
};

//查询工程师订单
export const queryEngineerOrderList = params => {
  return axios.post(`${base}/api/workOrder/order/query_engineer_order_list`, params);
};

//查询工程师物料
export const engineerInventoryList = params => {
  return axios.post(`${base}/api/customer_services/query_engineer_inventory_list`, params);
};

//派单管理  查询所在城市
export const queryRegion = params => {
  return axios.post(`${base}/system_region/query_sys_region`, params);
};


// 查看订单可指派人

export const queryEgineer = params => {
  return axios.post(`${base}/api/EngineerInfo/query_engineer`, params);
};

// 标记点单
export const setOrderTag = params => {
  return axios.get(`${base}/api/workOrder/order/set_order_tag`, { params: params });
};

//指派取机
export const assignFetcher = params => {
  return axios.post(`${base}/api/workOrder/order/assign_fetcher`, params);
};

//指派送机
export const assignDeliveryman = params => {
  return axios.post(`${base}/api/workOrder/order/assign_deliveryman`, params);
};

//订单支付
export const orderPay = params => {
  return axios.post(`${base}/api/workOrder/order/order_pay`, params);
};

//指派维修
export const sendOrders = params => {
  return axios.post(`${base}/api/workOrder/order/send_orders`, params);
};

//重置派单
export const revertSendOrders = params => {
  return axios.post(`${base}/api/workOrder/order/revert_send_orders`, params);
};


//查询故障小雷
export const selectFault = params => {
  return axios.post(`${base}/api/basicSetting/faultSubclass/selectFault`);
};

//  根据手机号查询订单
export const selectAfter = params => {
  return axios.post(`${base}/api/workOrder/order/selectAfter`, { param: params });
};

//新建售后订单，查询关联订单
export const selectBefor = params => {
  return axios.post(`${base}/api/workOrder/order/select_befor`, params);
};

//创建订单
export const createOrder = params => {
  return axios.post(`${base}/api/workOrder/order/createOrder`, params);
};

//创建订单转M3
export const createM3Order = params => {
  return axios.post(`${base}/api/workOrder/order/createM3Order`, params);
};

// 查询订单留言列表
export const getOrderMessage = params => {
  return axios.get(`${base}/api/workOrder/order_message/get_order_message`, { params: params });
};

// 新建订单留言
export const addOrderMessage = params => {
  return axios.post(`${base}/api/workOrder/order_message/add_order_message`, params);
};
// 删除订单留言
export const deleteOrderMessage = params => {
  return axios.get(`${base}/api/workOrder/order_message/delete_order_message`, { params: params });
};


//查询客服主管工单页面有多少状态数量
export const selectTotalOrderQuantity = params => {
  return axios.get(`${base}/api/workOrder/order/selectTotalOrderQuantity`, { params: params });
};

//查询普通客服工单页面有多少状态数量
export const selectTotalOrderApplyRmk = params => {
  return axios.post(`${base}/api/workOrder/order/selectTotalOrderApplyRmk`, params);
};

//查询门店前台工单页面有多少状态数量
export const selectShopOrderQuantity = params => {
  return axios.post(`${base}//api/workOrder/order/selectShopOrderQuantity`, params);
};

//获取订单数量 ， 某些特殊情况
export const getOrderTotal = params => {
  return axios.post(`${base}/api/workOrder/order/get_order_total`, params);
};


//获取订单详情
export const selectWorkOrderDetails = params => {
  return axios.get(`${base}/api/workOrder/order/getOrderDetails`, { params: params });
};

//获取编组名称
export const getLabelList = params => {
  return axios.post(`${base}/api/workOrder/order/get_label_list`, params);
};

//新建&编辑编组名称
export const setOrderLabel = params => {
  return axios.post(`${base}/api/workOrder/order/set_order_label`, params);
};

//批量派单
export const sendOrdersBatch = params => {
  return axios.post(`${base}/api/workOrder/order/send_orders_batch`, params);
};



//查询订单事件
export const selectWorkOrderIncident = params => {
  return axios.get(`${base}/api/workOrder/workorderincident/selectWorkOrderIncident`, { params: params });
};


//修改订单详情
export const changeOrderInfo = params => {
  return axios.post(`${base}/api/workOrder/order/change_order_info`, params);
};

//客服主管改派
export const assignedTheRepairOrder = params => {
  return axios.post(`${base}/api/workOrder/order/assignedTheRepairOrder`, params);
};

//获取普通客服列表
export const queryCustomerServices = params => {
  return axios.post(`${base}/api/customer_services/query_customer_services`, params);
};


//确认订单
export const ensureOrder = params => {
  return axios.post(`${base}/api/workOrder/order/ensure_order`, params);
};

//转单天玄系统
export const tianxuanOrder = params => {
  return axios.post(`${base}/api/workOrder/order/tianxuan_order`, params);
};


//转单M4系统
export const jhhToM3Order = params => {
  return axios.post(`${base}/api/workOrder/order/jhhToM3_order`, params);
};
//转单捷博系统
export const jieboOrder = params => {
  return axios.post(`${base}/api/workOrder/order/jiebo_order`, params);
};

//无法确认
export const unableToEnsure = params => {
  return axios.post(`${base}/api/workOrder/order/unable_to_ensure`, params);
};

//取消订单
export const cancelOrder = params => {
  return axios.post(`${base}/api/workOrder/order/cancel_order`, params);
};


//待维修待入库
export const standbyForMaintenance = params => {
  return axios.post(`${base}/api/workOrder/order/standby_for_maintenance`, params);
};


//维修后待处理
export const maintenancePending = params => {
  return axios.post(`${base}/api/workOrder/order/maintenance_pending`, params);
};


//寄出
export const sendOff = params => {
  return axios.post(`${base}/api/workOrder/order/send_off`, params);
};

//驳回
export const rejectOrder = params => {
  return axios.post(`${base}/api/workOrder/order/reject`, params);
};

//改派
export const reassignmentOrder = params => {
  return axios.post(`${base}/api/workOrder/order/reassignment`, params);
};

//设置上线线状态
export const updateAutomaticOrder = params => {
  return axios.post(`${base}/api/workOrder/customerServices/updateAutomaticOrder`, params);
};


export const selectAutomaticorder = params => {
  return axios.post(`${base}/api/workOrder/customerServices/selectAutomaticorder`, params);
};

//申请开票管理 开票列表
export const queryInvoiceList = params => {
  return axios.post(`${base}/api/workOrder/invoice/query_invoice_list`, params);
};
//申请开票管理 申请开票
export const applyInvoice = params => {
  return axios.post(`${base}/api/workOrder/invoice/apply_invoice`, params);
};
//申请开票管理 驳回申请
export const checkInvoice = params => {
  return axios.post(`${base}/api/workOrder/invoice/check_invoice`, params);
};

//退款申请管理 退款列表
export const queryRefundList = params => {
  return axios.post(`${base}/api/workOrder/refund/query_refund_list`, params);
};
//申请申请管理 申请退款
export const applyRefund = params => {
  return axios.post(`${base}/api/workOrder/refund/apply_refund`, params);
};
//申请申请管理 驳回申请
export const checkRefund = params => {
  return axios.post(`${base}/api/workOrder/refund/check_refund`, params);
};

//查看关联订单列表
export const getOrderList = params => {
  return axios.post(`${base}/api/workOrder/order/order_list`, params);
};

//财务中心 对账管理 对账列表
export const accountDayList = params => {
  return axios.post(`${base}/api/account_check_daily/query_list`, params);
};

//财务中心 对账管理 对账列表 月度信息
export const accountMonthlyList = params => {
  return axios.post(`${base}/api/account_check_monthly/query_list`, params);
};
//财务中心 对账管理 新建入账
export const accountCheckInfoAdd = params => {
  return axios.post(`${base}/api/account_check/account_check_info_add`, params);
};

//财务中心 对账管理 新建入账 工程师列表
export const engineerList = params => {
  return axios.post(`${base}/api/EngineerInfo/engineer_list`, params);
};

//财务中心 对账管理 新建入账 根据订单编号查询应付金额
export const getAmountPayable = params => {
  return axios.get(`${base}/api/workOrder/order/get_amount_payable`, { params: params });
};
//派单预派 工程师列表
export const engineerListArea = params => {
  return axios.post(`${base}/api/EngineerInfo/engineer_list_area`, params);
};

//派单预派 批量改派
export const revertOrdersBatch = params => {
  return axios.post(`${base}/api/workOrder/order/revert_orders_batch`, params);
};

//财务利润
export const profitReport = params => {
  return axios.post(`${base}/api/profit/profit_report`, params);
};

//工程师单量
export const engineerOrder = params => {
  return axios.post(`${base}/api/EngineerInfo/engineer_order`, params);
};

//查询每日单量
export const orderHourCount = params => {
  return axios.get(`${base}/api/workOrder/send_order/order_hour_count`, { params: params });
};


// WEBPACK FOOTER //
// ./src/api/order.js